import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LiftErrorService } from '../../services/lift-error.service';
import { EntityListRefresh } from 'src/app/core/services/entity-list.refresh';
import { ProgressBarService } from 'src/app/core/services/progress-bar.service';
import { LiftErrorCriteria } from '../../models/lift-error.criteria';
import { LiftErrorList } from '../../models/lift-error-list.model';
import { EntityDatatableComponent } from 'src/app/core/components/entity-datatable/entity-datatable.component';
import * as moment from 'moment';
import { HttpResponse } from '@angular/common/http';
import { Pagination } from '../../../core/models/pagination.model';
import { TranslateService } from '@ngx-translate/core';
import { LiftDetail } from '../../models/lift-detail.model';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators'
import { FormControl } from '@angular/forms';
import { UINotificationService } from '../../../core/services/ui-notification.service';
import { NotificationType } from '../../../core/models/ui-notification.model';

import { L10n, setCulture, loadCldr } from '@syncfusion/ej2-base';
import { LoginService } from '../../../user/services/login.service';
import { Observable } from 'rxjs';
import { forkJoin } from 'rxjs';
declare var require: any;

loadCldr(
  require("cldr-data/main/cs/numbers.json"),
  require("cldr-data/main/cs/ca-gregorian.json"),
  require("cldr-data/supplemental/numberingSystems.json"),
  require("cldr-data/main/cs/timeZoneNames.json"),
  //require('cldr-data/supplemental/weekdata.json') // To load the culture based first day of week
);


L10n.load({
  'cs': {
    datepicker: {
      placeholder: "Vyberte datum",
      today: "Dnes"
    }
  }
});

setCulture('cs');

@Component({
  selector: 'app-lift-error',
  templateUrl: './lift-error.component.html',
  styleUrls: ['./lift-error.component.css']
})
export class LiftErrorComponent extends EntityDatatableComponent<LiftErrorList, LiftErrorCriteria, LiftErrorService> {
  liftId: number;
  lift: LiftDetail;
  errorTypes = [];
  menu = 'errors';

  batchSelect = [];

  //Permissions
  canViewErrors: boolean = false;
  canView: boolean = false;
  canControl: boolean = false;
  canViewParameter: boolean = false;

  searchBox = new FormControl();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private liftErrorService: LiftErrorService,
    entityListRefresh: EntityListRefresh,
    progressBarService: ProgressBarService,
    public translateService: TranslateService,
    private uiNotificationService: UINotificationService,
    private loginService: LoginService
  ) {
    super(
      'lift-error',
      new LiftErrorCriteria(),
      entityListRefresh,
      liftErrorService,
      progressBarService
    );

    this.searchBox
      .valueChanges
      .pipe(
        debounceTime(400),
        distinctUntilChanged()
      ).subscribe(term => {
        this.filterByCode(term);
      });

    this.sortItems = [
      {
        title: 'Vybrat',
        code: 'Id',
        sortOrder: 'asc',
        width: 50,
        disabled: true,
        isEmpty: true,
        class: null
      },
      {
        title: 'liftError.dateTime',
        code: 'CreatedAt',
        sortOrder: 'desc',
        width: 156,
        disabled: false,
        isEmpty: false,
        class: null
      },
      {
        title: 'liftError.code',
        code: 'Code',
        sortOrder: 'asc',
        width: 200,
        disabled: false,
        isEmpty: false,
        class: null
      },
      {
        title: 'liftError.floor',
        code: 'Floor',
        sortOrder: 'asc',
        width: 100,
        disabled: false,
        isEmpty: false,
        class: null
      },
      {
        title: 'liftError.description',
        code: 'Description',
        sortOrder: 'asc',
        width: 200,
        disabled: true,
        isEmpty: false,
        class: null
      },
      {
        title: 'liftError.action',
        code: 'action',
        sortOrder: 'asc',
        width: 50,
        disabled: true,
        isEmpty: true,
        class: null
      }
    ];
  }

  ngOnInit() {
    this.liftId = +this.route.snapshot.paramMap.get('id');
    const response = this.route.snapshot.data.errors;
    this.errorTypes = this.route.snapshot.data.errorTypes.body;
    this.lift = this.route.snapshot.data.lift;

    let liftPermission = this.route.snapshot.data.liftPermission;
    if (!liftPermission) {
      liftPermission = [];
    }

    this.canViewErrors = liftPermission.indexOf('2') > -1 || this.loginService.isSuperadmin();
    this.canView = liftPermission.indexOf('0') > -1 || this.loginService.isSuperadmin();
    this.canControl = liftPermission.indexOf('3') > -1 || this.loginService.isSuperadmin();
    this.canViewParameter = liftPermission.indexOf('4') > -1 || this.loginService.isSuperadmin();

    this.initData(response);
  }

  formatDate(date: string) {
    if (!date) {
      return '-';
    }
    const lastLogin = moment(date);
    return lastLogin.format('DD.MM.YYYY HH:mm');
  }

  showErrorDescription(code: string) {
    const errorType = this.errorTypes.filter(item => item.code == code)[0];

    if (errorType) {
      return errorType.title;
    } else {
      return "Popis není definován v číselníku chyb."
    }
    
  }

  filterByCode(code: string) {
    this.criteria.code = code;
    this.criteria.page = 1;
    this.reloadData();
  }

  dateFromChanged() {
    this.reloadData();
  }

  dateToChanged() {
    this.reloadData();
  }

  delete(id: number) {
    if (confirm('Chcete opravdu smazat chybu ?')) {
      this.entityService.delete(id).subscribe(() => {
        this.uiNotificationService.add({
          type: NotificationType.Info,
          message: 'Chyba byla smazána'
        });
        this.reloadData();
      });
    }
  }

  reloadData() {
    this.progressBarService.start();
    this.entityService.get(this.criteria.paramsExport(), this.liftId)
      .subscribe((response: HttpResponse<LiftErrorList[]>) => {
        this.pagination = <Pagination>JSON.parse(response.headers.get('x-pagination'));
        this.entityList = <LiftErrorList[]>response.body;
        this.progressBarService.end();
      });
  }

  checkboxClick(event, id) {
    if (event.target.checked) {
      this.batchSelect.push(id);
    } else {
      const index = this.batchSelect.indexOf(id, 0);
      if (index > -1) {
        this.batchSelect.splice(index, 1);
      }
    }  
  }

  batchDeleteAction() {
    if (confirm('Chcete opravdu smazat všechny chyby ?')) {
      let calls = [];
      this.batchSelect.forEach(id => {
        calls.push(this.entityService.delete(id));
      });

      forkJoin(calls).subscribe(responses => {
        this.batchSelect = [];
        this.reloadData();
      });
      
    }
  }

}
